export default __webpack_public_path__ + "static/media/figure2.0c98bac8.csv";